<template>
  <div>
    <v-col cols="3">
      <v-btn
        block
        height="42px"
        color="#1db954"
        class="download-btn"
        @click="openModal('create')"
        style="color: black"
      >
        <v-icon>mdi mdi-plus-thick</v-icon>
        Neu
      </v-btn>
    </v-col>
    <v-data-table
      :key="locationUpdateKey"
      :headers="headers"
      :search="performSearch"
      :items="locations"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-text': 'Zeilen pro Seite',
      }"
    >
      <template v-slot:item.actions="{ item }">
        <div class="button-container">
          <v-icon
            small
            class="edit green--text icon-style"
            @click="openModal('update', item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="delete green--text icon-style"
            @click="openDeleteModal('delete', item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <create-location
      :location="{ abbreviation: '', name: '' }"
      :visible="dialogType === 'create'"
      :id="null"
      @close="closeModal"
      @addItem="addItem"
      v-on:updated-table="updatedList"
    />
    <update-location
      :key="locationUpdateKey"
      :location="selectedLocation"
      :visible="dialogType === 'update'"
      :id="selectedLocation.id"
      @close="closeModal"
      @updateItem="updateItem"
      v-on:updated-table="updatedList"
    />
    <delete-location
      :visible="dialogType === 'delete'"
      :location="selectedLocation"
      :item-list="itemList"
      v-on:updated-table="updatedList"
      @close="closeDeleteModal"
    ></delete-location>
  </div>
</template>

<script>
import CreateLocation from "./CreateLocation";
import UpdateLocation from "./UpdateLocation";
import DeleteLocation from "./DeleteLocation";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CreateLocation,
    UpdateLocation,
    DeleteLocation,
  },
  data() {
    return {
      headers: [
        { text: "Abkürzung", value: "abbreviation" },
        { text: "Beschreibung", value: "name" },

        { text: "", value: "actions", sortable: false },
      ],
      itemList: [],
      locationUpdateKey: null,
      locationList: [],
      isLoading: false,
      dialogType: "",
      selectedLocation: {},
      localSearch: null,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapGetters(["getSearchquery", "locations"]),

    performSearch() {
      return this.getSearchquery;
    },
  },
  mounted() {
    this.localSearch = this.getSearchquery;
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["fetchLocations", "createLocation", "updateLocation"]),
    editLocation(location) {
      this.selectedLocation = { ...location };
      this.dialogType = "update";
    },
    updatedList(boolean) {
      if (boolean) {
        this.fetchData();
      }
    },

    openModal(type, location) {
      this.dialogType = type;
      if (type === "update") {
        this.selectedLocation = { ...location };
      }
    },
    openDeleteModal(type, location) {
      this.dialogType = type;
      if (type === "delete") {
        this.selectedLocation = { ...location };
      }
    },

    closeModal() {
      this.dialogType = "";
      this.selectedLocation = {};
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.dialogType = "";
      this.selectedLocation = {};
    },
    async addItem(newItem) {
      this.isLoading = true;
      await this.createLocation(newItem);
      this.closeModal();
    },
    async updateItem(item) {
      this.isLoading = true;
      await this.updateLocation(item);
      this.locationUpdateKey += 1;
      this.closeModal();
    },
    fetchData() {
      this.isLoading = true;
      this.fetchLocations()
        .then(() => {
          this.$store.commit("setLocationTypeResults", response.data);
          this.locations = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
  handleSearch(query) {
    this.getSearchquery = query;
  },
};
</script>
<style lang="scss" scoped>
.icon-style {
  border: 1px solid #494949;
  padding: 3px;
  border-radius: 5px;
  width: 42px;
  height: 42px;
  margin-left: -60px !important;
}

.button-container {
  display: flex;
  align-items: center;
}
.button-container .delete {
  position: absolute;
  right: 15px;
}
.button-container .edit {
  position: absolute;
  right: 67px;
}
.add-button {
  outline: none !important;
  margin-bottom: 10px;
  width: 220px;
}
</style>
